// extracted by mini-css-extract-plugin
module.exports = {"root":"privacy-policy-module--root--1nzI4","title":"privacy-policy-module--title--S3vKH"};